export default __webpack_public_path__ + "static/media/4696@3x.a9f135aa.png";